const faqs = [
  {
    "@type": "Question",
    name: "Kostar det något att registrera sig på plattformen?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      För dig som hyresgäst så kostar det ingenting att söka lokal på Vakansa och du behöver inte registrera dig!

      Du kan filtrera fram lokaler på Lediga Lokaler utifrån dina exakta preferenser och skicka förfrågan till våra hyresvärdar hur mycket du vill - så länge du inte spammar och/eller inte svarar på
      våra kontrollfrågor. För att säkerställa att de hyresgäster och hyresvärdar som får kontakt med varandra via
      Vakansa ska få den bästa upplevelsen hör vi av oss regelbundet för att se hur det går. Om du underlåter dig att
      svara kommer vi debitera dig en straffavgift.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Hur gör jag för att hyra en lokal via Vakansa?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      När du hittat en lokal du vill hyra klickar du på “Skicka förfrågan” knappen på annonsen där du kan meddela vad
      du avser göra i lokalen, tid och dag du önskar hyra lokalen, samt andra önskemål till hyresvärden. Därefter
      återkommer vi med eventuella frågor och ordnar med en visning av lokalen om lokalen är tillgänglig när ni önskar
      använda den. Om allt ser bra ut upprättas ett kontrakt mellan er och hyresvärden och du får tillträde till
      lokalen.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Vad kostar det att använda Vakansa?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      För dig som hyresgäst kostar det inget att hyra en lokal via Vakansa utan det är hyresvärden som betalar en
      förmedlingsavgift till oss på Vakansa som betalning för vår tjänst.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Hur går uthyrningsprocessen till?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
       När du skickat en förfrågan på en lokal via Vakansa skickas ett "matchningsmejl" till dig,
       hyresvärden och Vakansa. Detta representerar förmedlingen. Det är via detta matchningsmejl som Vakansa följer
       uthyrningsprocessen. Ni får i matchningsmejlet information om varandras kontaktuppgifter för att kunna ta
       samtalet vidare. Här avgör hyresvärden om den vill ta kontakt med er för en visning eller avböja uthyrning. När
       en visning väl genomförts och ni kommit överens om en förhyrning så ordnar ni själva med avtal och allt det
       praktiska för att gå i mål med uthyrningsprocessen. Oavsett om en uthyrning blir av eller inte är det ert ansvar
       att informera oss på Vakansa om hur det går.

       OBS: För att vi på Vakansa ska kunna upprätthålla vårt ansvar åtar Ni er som användare av våra tjänster, att
       besvara våra kontrollfrågor om hur uthyrningsprocessen med förmedlad part fortskrider. Om du som Hyresvärd
       underlåter dig att svara, efter att vi gjort våra tre (3) kontaktförsök, utgår en straffavgift. Om du som
       Hyresgäst underlåter dig att svara, efter att vi gjort våra tre (3) kontaktförsök, kommer en straffavgift om 500
       kr debiteras din organisation. Detta i enlighet med våra användarvillkor.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Kan ni hjälpa till med att skriva kontrakt parterna emellan?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
       Vakansa har två prismodeller, “Vakansa Bas” och “Vakansa Mest”, varav “Vakansa Mest” omfattar juridisk hjälp med
       att upprätta kontrakt parterna emellan oavsett om lokalen är en momsad lokal eller icke momsad lokal.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Hanterar eller begär Vakansa depositioner?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Vakansa tar inte och hanterar inga depositioner via vår plattform, men kan vara behjälplig i frågor som rör
      depositioner. Vi rekommenderar alltid Hyresvärdar att ta en deposition i syfte att ha en säkerhet vid eventuella
      framtida risker och ta betalt i förskott. Detta är det sedvanliga sättet att göra det på som Hyresgäst.
      Depositionen brukar ligga på mellan 1-6 månadshyror för längre uthyrningar eller en kännbar summa vid kortare
      uthyrningar, beroende på lokalens storlek och ändamål.

      Om du inte vill betala en deposition och du får krav på det - hör av dig så kan vi hjälpa dig med en
      depositionspremie istället! En försäkring som innebär att du inte behöver ligga ute med pengar, men fortfarande
      garanterar det skydd hyresvärden är ute efter.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Är lokalerna via Vakansa försäkrade?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Vakansa ansvarar inte för skador som uppkommer i lokaler, på fönster, skyltfönster, dörrar eller portar som hör
      till lokaler eller som finns i direkt anslutning till lokaler. Detta gäller oavsett vem eller vad som orsakat
      skadan. Varje Hyresvärd och Hyresgäst ansvarar för sitt eget försäkringsbehov och vi rekommenderar att man
      åtminstone ska ha en verksamhetsförsäkring.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Tar ni någon kreditupplysning på mig som hyresgäst?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Vi har som krav på Vakansa att alla hyresgäster måste ange organisationsnummer för att kunna skicka en förfrågan
      på lokal. Detta ger hyresvärden möjlighet att göra en kreditupplysning själva.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Vad förbinder jag mig till när jag använder Vakansa?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Du förbinder dig att följa våra Användarvillkor.
      `,
    },
  },
];

export const jsonLdSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs,
};
